// extracted by mini-css-extract-plugin
module.exports = {"ReviewWrap":"Review_ReviewWrap__AXoao"};